// extracted by css-extract-rspack-plugin
export default {"Table":"Table-module__Table___Oi1mB"};